<template>
  <div class="h-100 chat-center-container">
    <v-layout row wrap h-100>
      <v-flex xs12 class="position-relative">
        <vue-perfect-scrollbar>
          <v-container>
            <v-layout column>
              <!-- <v-flex xs12>
                <agencies></agencies>
              </v-flex> -->
              <v-flex xs12>
                <distribution :loaded-charts="loadedCharts"></distribution>
              </v-flex>
              <v-flex>
                <v-container grid-list-lg>
                  <v-layout row>
                    <v-flex md4>
                      <agents :loaded-charts="loadedCharts" :channel="pusherChannel" @showAgent="showAgents = true"></agents>
                    </v-flex>
                    <v-flex md8>
                      <wait-time :loaded-charts="loadedCharts" @showAgent="showAgents = true"></wait-time>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
              <v-flex>
                <v-container grid-list-lg>
                  <v-layout row>
                    <v-flex xs12>
                      <solved :loaded-charts="loadedCharts" :channel="pusherChannel"></solved>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </vue-perfect-scrollbar>
      </v-flex>
    </v-layout>
    <agent-modal :show="showAgents" @close="showAgents = $event"></agent-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Agencies from './Agencies';
import Distribution from './Distributions/Index';
import Agents from './Agents';
import WaitTime from './WaitTime';
import SideBtn from '../Button';
import Solved from './Solved/Index';
import AgentModal from './AgentsModal';

export default {
  components: {
    VuePerfectScrollbar,
    Distribution,
    AgentModal,
    WaitTime,
    Agencies,
    SideBtn,
    Solved,
    Agents,
  },
  created() {
    this.$store.dispatch('INITIALIZE_CHART');
  },
  beforeDestroy() {
    window.Echo.leave(`company.${this.user.company_id}.chatCenterReport`);
  },
  data() {
    return {
      showAgents: false,
    };
  },
  computed: {
    ...mapGetters([
      'loadedCharts',
    ]),
    pusherChannel() {
      return window.Echo.private(`company.${this.user.company_id}.chatCenterReport`);
    },
    user() {
      return this.$auth.user();
    },
  },
};
</script>

<style scoped>
  .position-relative {
    position: relative;
  }
  .position-absolute {
    position: absolute;
  }
  .drawer {
    width: 100% !important;
    z-index: 1;
    position: relative;
  }
  .navbar-header {
    height: 64px;
  }
  .navbar-footer {
    height: 32px;
  }
  .thumbnail {
    border: 2px solid #d3d3d3;
    height: 64px;
    overflow: hidden;
    border-radius: 6px;
  }
  .img-responsive {
    width: 100%;
  }
  .navigation-drawer >>> .toolbar__content {
    height: 96px !important;
  }
  .semi-border--left {
    position: relative;
  }
  .semi-border--left:before {
    top: 50%;
    left: 1em;
    width: 1px;
    height: 70%;
    border: 1px solid #d3d3d3;
    content: '';
    position: absolute;
    transform: translateY(-50%);
  }
  .chat-list-container {
    height: calc(100vh - 152px);
  }
  .chat-center-container >>> .chat-modal {
    max-height: 95% !important; 
    overflow: visible;
  }
  .blured {
    filter: blur(5px);
  }
  .border {
    border: 1px solid #d3d3d3;
    border-radius: 4px;
  }
  .border-bottom {
    border-bottom: 1px solid #d3d3d3;
  } 
  .border-left {
    border-left: 1px solid #d3d3d3;
  }
  .border-right {
    border-right: 1px solid #d3d3d3;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .text-truncate {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>





// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/Index.vue